/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsBoolResponse
 */
export interface SharedserviceMelcoModelsBoolResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SharedserviceMelcoModelsBoolResponse
     */
    result?: boolean;
}

export function SharedserviceMelcoModelsBoolResponseFromJSON(json: any): SharedserviceMelcoModelsBoolResponse {
    return SharedserviceMelcoModelsBoolResponseFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsBoolResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsBoolResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function SharedserviceMelcoModelsBoolResponseToJSON(value?: SharedserviceMelcoModelsBoolResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}


